/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import dayjs from "dayjs";
import Config from "data/config";
import { getPrimaryDate, hasPrimaryDate } from "cms/models/helpers";

const ResultItem = (props) => {
    const model = props?.model;
    if (!model) {
        return;
    }
    const guid = model?.guid;
    const title = model?.title;
    const description = model?.description;
    const hasDate = hasPrimaryDate(model);
    let primary_date;
    if (hasDate) {
        const dateData = getPrimaryDate(model);
        const date = dateData?.date;
        primary_date = date ? dayjs(date).format(Config.dates.display.date) : undefined;
    }
    
    return (
        <div className="views-row views-row-1 views-row-odd views-row-first">
            <div className="ds-1col node node-news node-promoted node-teaser view-mode-teaser clearfix">
                <h3 className="title">
                    <a href={`/composer/${guid}`}>
                        {title}
                    </a>
                </h3>
                {primary_date &&
                    <div className="field field-name-post-date">
                        {primary_date}
                    </div>
                }
                <div className="field field-name-field-content">
                    <p>{description}</p>
                </div>
            </div>
        </div>
    );
};

export { ResultItem };
